export default "__VITE_PUBLIC_ASSET__925fb41e__"